import Link from "next/link";
import Image from "next/image";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { MapPinIcon, CalendarIcon } from "lucide-react";

import { CategoryBadge } from "@/components/events/CategoryBadge";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { EVENT_TYPES, type EventCategoryKey, type EventTypeKey } from "@/lib/constants";
import { toDisplayDate } from "@/lib/eventDate";

export type PublicEvent = {
  id: number;
  title: string;
  eventType: EventTypeKey;
  category: EventCategoryKey;
  startsAt: string;
  venue: string;
  city: string;
  price: string | null;
  imageUrl: string | null;
  organizationName: string;
};

export function EventCard({ event }: { event: PublicEvent }) {
  const date = new Date(event.startsAt);

  return (
    <Link href={`/eventos/${event.id}`} className="block h-full">
      <Card className="h-full overflow-hidden transition-shadow hover:shadow-md">
        {event.imageUrl && (
          <div className="-mt-4 mb-1">
            <Image
              src={event.imageUrl}
              alt=""
              width={400}
              height={220}
              className="h-40 w-full object-cover"
            />
          </div>
        )}
        <CardHeader>
          <div className="flex items-start justify-between gap-2">
            <CategoryBadge category={event.category} />
            <span className="shrink-0 text-xs font-medium text-muted-foreground">
              {event.city}
            </span>
          </div>
          <h3 className="font-heading text-lg leading-snug font-semibold">{event.title}</h3>
          <p className="text-xs text-muted-foreground">{EVENT_TYPES[event.eventType]}</p>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <div className="flex flex-col gap-1 text-sm text-foreground/80">
            <span className="flex items-center gap-1.5">
              <CalendarIcon className="size-3.5 text-primary" />
              {format(date, "EEEE d 'de' MMMM, HH:mm'h'", { locale: es })}
            </span>
            <span className="flex items-center gap-1.5">
              <MapPinIcon className="size-3.5 text-primary" />
              {event.venue}
            </span>
          </div>
          <span className="mt-1 text-xs font-medium text-muted-foreground">
            Organiza: {event.organizationName}
          </span>
        </CardContent>
      </Card>
    </Link>
  );
}
